// extracted by mini-css-extract-plugin
export default {"mnInput":"custom-input_mnInput__xj5JY","icon":"custom-input_icon__Pmv9e","input":"custom-input_input__XJ1R6","textarea":"custom-input_textarea__1Hwhw"};